<template>
  <div>
    <!-- 1. CARD: PROJEKTBUDGET -->
    <b-overlay :show="isLoading" style="height: 160px">
      <b-card class=" text-center" body-class="p-0">
        <!-- HAUPTWERT -->
        <div class="row mx-0">
          <div class="col-12 px-3 py-2 text-left ">
            <h5 class="text-muted">Projektbudget</h5>
            <span v-if="stats.patBudgetOpen && stats.patBudgetOpen !== 0" class="float-right">
              <h5 class="text-muted mt-1">
                ({{ stats.patBudgetOpen && stats.patBudgetOpen > 0 ? '+' : ''
                }}{{ formatCurrency(stats.patBudgetOpen) }})
              </h5>
            </span>
            <h3 class="mb-0 text-center text-nowrap">{{ formatCurrency(stats.projectBudget) }}</h3>
          </div>
        </div>
        <!-- PROGRESSBAR ELEMENTE -->
        <div class="row mx-0">
          <div class="col pb-2">
            <b-progress :max="100" show-progress striped style="border-radius: 5px">
              <b-progress-bar :label="'KKE'" variant="primary" :value="(stats.kkeBudget / stats.projectBudget) * 100" />
              <b-progress-bar :label="'PÄT'" variant="warning" :value="(stats.patBudget / stats.projectBudget) * 100" />
              <b-progress-bar
                :label="'PÄT (offen)'"
                variant="info"
                :value="(stats.patBudgetOpen / stats.projectBudget) * 100"
              />
            </b-progress>
          </div>
        </div>
        <!-- DETAILWERTE -->
        <div class="row mx-0">
          <div class="col-4 border-top border-right px-3 py-1 ">
            <div class="text-left text-muted">
              <span class="bg-primary mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
              <small>KKE-Budget</small>
            </div>
            <div class="text-center text-nowrap">
              {{ formatCurrency(stats.kkeBudget) }}
            </div>
          </div>
          <div class="col-4  border-top border-right px-3 py-1">
            <div class="text-left text-muted text-nowrap text-truncate">
              <span class="bg-warning mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
              <small>PÄT-Budget</small>
            </div>
            <div class="text-center text-nowrap">
              {{ formatCurrency(stats.patBudget) }}
            </div>
          </div>
          <div class="col-4  border-top border-right px-3 py-1">
            <div class="text-left text-muted">
              <span class="bg-info mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
              <small>Offene PÄT</small>
            </div>
            <div class="text-center text-nowrap">
              {{ formatCurrency(stats.patBudgetOpen) }}
            </div>
          </div>
        </div>
      </b-card>
    </b-overlay>
    <!-- 2. CARD: VERGABEEINHEITEN -->
    <b-overlay :show="isLoading" style="height: 160px">
      <div class="row mt-4">
        <div class="col-12">
          <b-card class=" text-center" body-class="p-0">
            <div class="row mx-0">
              <div class="col-12 px-3 py-2 text-left ">
                <h5 class="text-muted">Vergabeeinheiten</h5>
                <h3 class="mb-0 text-center text-nowrap">{{ formatCurrency(stats.veBudget) }}</h3>
              </div>
            </div>
            <div class="row mx-0">
              <div class="col pb-2">
                <b-progress :max="100" show-progress striped style="border-radius: 5px">
                  <b-progress-bar
                    :label="((stats.veBudgetOpen / stats.veBudget) * 100).toFixed(1) + '%'"
                    variant="info"
                    :value="(stats.veBudgetOpen / stats.veBudget) * 100"
                  />
                  <b-progress-bar
                    :label="((stats.veBudgetAusschreibung / stats.veBudget) * 100).toFixed(1) + '%'"
                    variant="warning"
                    :value="(stats.veBudgetAusschreibung / stats.veBudget) * 100"
                  />
                  <b-progress-bar
                    :label="((stats.veBudgetInWork / stats.veBudget) * 100).toFixed(1) + '%'"
                    variant="primary"
                    :value="(stats.veBudgetInWork / stats.veBudget) * 100"
                  />
                  <b-progress-bar
                    variant="success"
                    :value="(stats.veBudgetSchlussgerechnet / stats.veBudget) * 100"
                    :label="((stats.veBudgetSchlussgerechnet / stats.veBudget) * 100).toFixed(1) + '%'"
                  />
                </b-progress>
              </div>
            </div>

            <div class="row mx-0">
              <div class="col-3 border-top border-right px-3 py-1 ">
                <div class="text-left text-muted">
                  <span class="bg-info mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
                  <small>offen</small>
                </div>
                <div class="text-center text-nowrap">
                  {{ formatCurrency(stats.veBudgetOpen) }}
                </div>
              </div>
              <div class="col-3  border-top border-right px-3 py-1">
                <div class="text-left text-muted text-nowrap text-truncate">
                  <span class="bg-warning mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
                  <small>in Ausschreibung/Vergabe</small>
                </div>
                <div class="text-center text-nowrap">
                  {{ formatCurrency(stats.veBudgetAusschreibung) }}
                </div>
              </div>
              <div class="col-3  border-top border-right px-3 py-1">
                <div class="text-left text-muted">
                  <span class="bg-primary mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
                  <small>in Arbeit</small>
                </div>
                <div class="text-center text-nowrap">
                  {{ formatCurrency(stats.veBudgetInWork) }}
                </div>
              </div>
              <div class="col-3  border-top px-3 py-1">
                <div class="text-left text-muted">
                  <span class="bg-success mr-1 d-inline-block rounded-circle" style="width:10px;height:10px;"></span>
                  <small>schlussgerechnet</small>
                </div>
                <div class="text-center text-nowrap">
                  {{ formatCurrency(stats.veBudgetSchlussgerechnet) }}
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ProjectService from '@/service/ProjectsService';
import settingsStore from '@/store/Settings';
//import AppState from '@/store/App.js';
export default {
  mounted() {
    this.loadOrUpdateData();
    this.$eventBus.$on('projectSwitched', () => {
      this.loadOrUpdateData();
    });
    //console.log('mounted DashboardLine.vue');
    //this.loadData();
  },
  activated() {
    this.loadOrUpdateData();
  },
  data() {
    return {
      isLoading: true,
      stats: {
        countVe: null,
        countKke: null,
        projectBudget: null,
        kkeBudget: null,
        patBudget: null,
        projectBudgetAllocated: null,
        veBudget: null,
        veBudgetOpen: null,
        veBudgetInWork: null,
        veBudgetAusschreibung: null,
        veBudgetSchlussgerechnet: null
      }
    };
  },
  methods: {
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    loadOrUpdateData() {
      this.isLoading = true;
      ProjectService.getProjectStatisticsByProjectId().then(stats => {
        this.stats.countVe = stats.countVe;
        this.stats.countKke = stats.countKke;
        this.stats.projectBudget = stats.KkeBudgetSummary + stats.PatBudgetSummary;
        this.stats.projectBudgetAllocated = stats.KkeBudgetAllocatedSummary + stats.PatBudgetAllocatedSummary;
        this.stats.kkeBudget = stats.KkeBudgetSummary;
        this.stats.patBudget = stats.PatBudgetSummary;
        this.stats.patBudgetOpen = stats.PatBudgetOpen;

        this.stats.veBudgetOpen = stats.VEBudgetOpen;
        this.stats.veBudgetInWork = stats.VEBudgetInArbeit;
        this.stats.veBudgetAusschreibung = stats.VEBudgetAusgeschrieben + stats.VEBudgetAusgewertet;
        this.stats.veBudgetSchlussgerechnet = stats.VEBudgetInvoiced;

        this.stats.veBudget =
          this.stats.veBudgetOpen +
          this.stats.veBudgetInWork +
          this.stats.veBudgetAusschreibung +
          this.stats.veBudgetSchlussgerechnet;

        this.isLoading = false;
      });
    }
  }
};
</script>
